// MX message element aliases for human-readable labels
export const mxElementAliases: Record<string, string> = {
  "GroupHeader": "Group Header",
  "MessageIdentification": "Message Identification",
  "CreationDateTime": "Creation Date/Time",
  "NumberOfTransactions": "Number of Transactions",
  "TotalInterbankSettlementAmount": "Total Interbank Settlement Amount",
  "SettlementInformation": "Settlement Information",
  "SettlementMethod": "Settlement Method",
  "SettlementAccount": "Settlement Account",
  "ClearingSystem": "Clearing System",
  "PaymentIdentification": "Payment Identification",
  "PaymentTypeInformation": "Payment Type Information",
  "InstructingAgent": "Instructing Agent",
  "InstructedAgent": "Instructed Agent",
  "CreditTransferTransactionInformation": "Credit Transfer Transaction Information",
  "InstructionIdentification": "Instruction Identification",
  "EndToEndId": "End to End ID",
  "TransactionIdentification": "Transaction Identification",
  "ClearingSystemReference": "Clearing System Reference",
  "InterbankSettlementAmount": "Interbank Settlement Amount",
  "InterbankSettlementDate": "Interbank Settlement Date",
  "InstructedAmount": "Instructed Amount",
  "ChargeBearer": "Charge Bearer",
  "ChargesInformation": "Charges Information",
  "PreviousInstructingAgent1": "Previous Instructing Agent 1",
  "IntermediaryAgent1": "Intermediary Agent 1",
  "IntermediaryAgent1Account": "Intermediary Agent 1 Account",
  "UltimateDebtor": "Ultimate Debtor",
  "Debtor": "Debtor",
  "PostalAddress": "Postal Address",
  "AddressType": "Address Type",
  "Department": "Department",
  "SubDepartment": "Sub Department",
  "StreetName": "Street Name",
  "BuildingNumber": "Building Number",
  "BuildingName": "Building Name",
  "Floor": "Floor",
  "PostBox": "Post Box",
  "Room": "Room",
  "PostCode": "Post Code",
  "TownName": "Town Name",
  "TownLocationName": "Town Location Name",
  "DistrictName": "District Name",
  "CountrySubDivision": "Country Sub Division",
  "Country": "Country",
  "AddressLines": "Address Lines",
  "Identification": "Identification",
  "CountryOfResidence": "Country of Residence",
  "Contact": "Contact",
  "DebtorAccount": "Debtor Account",
  "Iban": "IBAN",
  "Other": "Other",
  "Type": "Type",
  "Currency": "Currency",
  "Name": "Name",
  "Proxy": "Proxy",
  "DebtorAgent": "Debtor Agent",
  "FinancialInstitutionIdentification": "Financial Institution Identification",
  "BICFI": "BIC",
  "ClearingSystemMemberIdentification": "Clearing System Member Identification",
  "ClearingSystemIdentification": "Clearing System Identification",
  "Code": "Code",
  "Proprietary": "Proprietary",
  "MemberIdentification": "Member Identification",
  "LEI": "LEI",
  "BranchIdentification": "Branch Identification",
  "CreditorAgent": "Creditor Agent",
  "Creditor": "Creditor",
  "CreditorAccount": "Creditor Account",
  "UltimateCreditor": "Ultimate Creditor",
  "InstructionForCreditorAgent": "Instruction For Creditor Agent",
  "InstructionForNextAgent": "Instruction For Next Agent",
  "Purpose": "Purpose",
  "RegulatoryReporting": "Regulatory Reporting",
  "RemittanceInformation": "Remittance Information",
  "Unstructured": "Unstructured",
  "Structured": "Structured",
  "SupplementaryData": "Supplementary Data",
  "PlaceAndName": "Place And Name",
  "Envelope": "Envelope",
  "Value": "Value",
  // Add more aliases as needed for specific ISO 20022 elements
};

// Parse JSON string to object
export const parseJsonMessage = (jsonString: string): any => {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Error parsing JSON message:', error);
    return null;
  }
};

// Download XML as file
export const downloadMxMessageAsXml = (xmlString: string, paymentId: string): void => {
  const blob = new Blob([xmlString], { type: 'application/xml' });
  const url = URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = `payment-${paymentId}.xml`;
  document.body.appendChild(a);
  a.click();
  
  // Cleanup
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
};

// Convert JSON to XML (simple implementation)
export const jsonToXml = (jsonObj: any, indent: string = ''): string => {
  let xml = '';
  
  for (const prop in jsonObj) {
    if (jsonObj.hasOwnProperty(prop)) {
      const value = jsonObj[prop];
      
      if (value === null || value === undefined) {
        xml += `${indent}<${prop}/>\\n`;
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          // Handle arrays
          for (const item of value) {
            if (typeof item === 'object') {
              xml += `${indent}<${prop}>\\n${jsonToXml(item, indent + '  ')}${indent}</${prop}>\\n`;
            } else {
              xml += `${indent}<${prop}>${item}</${prop}>\\n`;
            }
          }
        } else {
          // Handle nested objects
          xml += `${indent}<${prop}>\\n${jsonToXml(value, indent + '  ')}${indent}</${prop}>\\n`;
        }
      } else {
        // Handle primitive values
        xml += `${indent}<${prop}>${value}</${prop}>\\n`;
      }
    }
  }
  
  return xml;
};

// Generate XML from JSON
export const generateXmlFromJson = (jsonObj: any): string => {
  const xml = `<?xml version="1.0" encoding="UTF-8"?>\\n${jsonToXml(jsonObj, '')}`;
  return xml;
}; 